<template>
<div>
    <b-row>
        <b-col cols="12">
            <img class="mr-2" src="/static-appopensalud/img/icons/cart-grey.svg" height="30" width="30" />
            <h4 class="summary-title" v-html="$t('payments.buySummary')"></h4>
        </b-col>
        <hr>
        <b-col class="mt-3" cols="12" sm="8">
            <label class="block" v-html="$t('payments.product')"></label>
            <span class="bold" v-html="productDescription"></span>
        </b-col>
        <b-col class="mt-3" cols="12" sm="4">
            <label class="block" v-html="$t('payments.price')"></label>
            <span v-html="`${price} ${currency}`"></span>
        </b-col>
        <!--TODO: Not finished. Fill in when necessary comparing with 'paytpv-template.html'-->
    </b-row>
    <b-row class="mt-4">
        <b-col cols="6" class="align-center">
            <back-button withoutButton :action="() => $emit('back')"></back-button>
        </b-col>
        <b-col class="align-right" cols="6">
            <base-button @click="goPaymentStep">{{$t('continue')}}</base-button>
        </b-col>
    </b-row>
</div>
</template>

<script>
import BaseButton from '../base/buttons/BaseButton'
import BackButton from '../base/buttons/BackButton'
import { getCurrencyByDomain } from '@/constants/currencies'
import { getPaymentTitleById } from '@/constants/paymentTypes'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'payments'

export default {
    components: {
        BaseButton,
        BackButton
    },
    props: {
      paymentType: Number,
      price: Number,
      paymentDescription: String
    },
    mixins: [i18nMixin(I18N_FILE)],
    created () {
    },
    data () {
        return {
        }
    },
    computed: {
      currency () {
        return getCurrencyByDomain()
      },
      productDescription () {
        return this.paymentDescription || getPaymentTitleById(this.paymentType)
      }
    },
    methods: {
      goPaymentStep () {
        this.$emit('nextStep')
      }
    }
}
</script>

<style scoped lang="scss">
.block{
  display: block;
}
.summary-title{
    display: inline-block;
    margin-bottom: 0;
}
.align-right{
    text-align: right;
}
.align-center{
    align-content: center;
}
.bold{
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/payment/PaymentSummary.vue